import { render, staticRenderFns } from "./CardAtendimentos.vue?vue&type=template&id=c9fa39fe&"
import script from "./CardAtendimentos.vue?vue&type=script&lang=js&"
export * from "./CardAtendimentos.vue?vue&type=script&lang=js&"
import style0 from "./CardAtendimentos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports